import GrapeIcon from "@/assets/icons/common/grapes.svg?react";
import { StarFilled } from "@ant-design/icons";
import { Rate } from "antd";
import clsx from "clsx";
import styles from "./ReviewRate.module.css";

export const ReviewRate = ({
  value,
  title,
  mini = false,
}: {
  value: number;
  title?: string;
  mini?: boolean;
}) => {
  if (mini) {
    return (
      <div className={clsx(styles.rate, styles.mini, "flex !items-center flex-row gap-1 !pl-0")}>
        <StarFilled className="w-4 h-4" style={{ color: "var(--global-color-link)" }} />
        <span className="roboto-font text-[var(--global-color-link)]">
          {value.toFixed(1)} ({title})
        </span>
      </div>
    );
  }

  return (
    <div className={styles.rate}>
      <div className={styles.isRate}>
        <Rate
          value={value}
          characterRender={(_, props) => {
            const index = props.index ?? 0;
            const current = value;
            const filled = index + 1 <= current;

            return (
              <GrapeIcon
                style={{
                  fill: filled ? "var(--global-color-link)" : "#d9d9d978",
                }}
              />
            );
          }}
        />
      </div>
      <div className={clsx(styles.titleRate, "gap-2 flex")}>
        {value > 0 && <span className={`roboto-font !text-[14px]`}>{value.toFixed(1)}</span>}

        <span className="roboto-font !ml-2 shrink-0">{title}</span>
      </div>
    </div>
  );
};
